
import React from "react";
import { SectionProps } from "@/types";
import { cn } from "@/lib/utils";

/**
 * Reusable Section component with consistent styling
 */
const Section: React.FC<SectionProps> = ({ 
  id, 
  className,
  children 
}) => {
  return (
    <section
      id={id}
      className={cn(
        "py-12 md:py-16 lg:py-20",
        className
      )}
    >
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        {children}
      </div>
    </section>
  );
};

export default Section;
